import styled from 'styled-components';
import { SIZES, SHAPES } from './ProductImage.constants';

interface BaseProductImageProps {
  size: SIZES;
  shape: SHAPES;
  src: string;
}

export const BaseProductImage = styled.img<BaseProductImageProps>`
  flex-shrink: 0;
  width: ${({ size }) => (size === SIZES.md ? '80px' : '56px')};
  height: ${({ size }) => (size === SIZES.md ? '80px' : '56px')};
  border-radius: ${({ shape }) => (shape === SHAPES.rounded ? '50%' : '0')};
  object-fit: contain;
  display: block;
`;
